import { useEffect, useState } from "react";
import api from "../../lib/api";
import { useLang } from "../../i18n";

export default function CustomersAdmin() {
  const { t } = useLang();
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-customers">
      <h1 className="font-serif text-3xl font-bold">{t("admin.customers")}</h1>
      <div className="mt-8 bg-slate2 border border-slate-700 rounded-lg overflow-x-auto">
        <table className="w-full text-sm" data-testid="customers-table">
          <thead>
            <tr className="border-b border-slate-700 text-left font-mono text-[10px] uppercase tracking-widest text-slate-400">
              <th className="px-5 py-4">Nome</th><th className="px-5 py-4">Email</th>
              <th className="px-5 py-4">Ruolo</th><th className="px-5 py-4">Registrato</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} className="border-b border-slate-700/50 hover:bg-slate-700/20" data-testid={`customer-row-${c.id}`}>
                <td className="px-5 py-3.5 font-medium text-slate-200">{c.name}</td>
                <td className="px-5 py-3.5 text-slate-400">{c.email}</td>
                <td className="px-5 py-3.5"><span className={`text-xs font-mono ${c.role === "admin" ? "text-gold" : "text-slate-400"}`}>{c.role}</span></td>
                <td className="px-5 py-3.5 text-slate-500 text-xs font-mono">{c.created_at ? new Date(c.created_at).toLocaleDateString("it-IT") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
